<div class="modal-header">
    <h4 class="modal-title">{{ 'New Candidate' | translate }}</h4>
    <button type="button" class="btn-close" aria-label="Close" (click)="onCancel()"></button>
  </div>
  <div class="modal-body">
    <form #candidateForm="ngForm">
        <div class="mb-3">
            <label for="name" class="form-label">{{ 'Name' | translate }}</label>
            <input type="text" id="name" class="form-control" [(ngModel)]="candidate.name" name="name" required>
        </div>
        <div class="mb-3">
            <label for="email" class="form-label">{{ 'Email' | translate }}</label>
            <input type="text" id="email" class="form-control" [(ngModel)]="candidate.email" name="email" required>
        </div>
        <div class="mb-3">
            <label for="phone" class="form-label">{{ 'Phone' | translate }}</label>
            <input type="text" id="phone" class="form-control" [(ngModel)]="candidate.phone" name="phone" required>
        </div>
        <div class="mb-3">
          <label for="attachment">{{ 'Attachment' | translate }}</label>
          <input type="file" class="form-control" (change)="onFileChange($event)">
          <a *ngIf="document" target="_blank" [href]="document?.url">{{ 'Open File' | translate }}</a>
        </div>
    </form>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-secondary" (click)="onCancel()">{{ 'Close' | translate }}</button>
    <button type="button" class="btn btn-primary" (click)="onSave()" [disabled]="!candidateForm.form.valid">{{ 'Save' | translate }}</button>
  </div>
  